module.exports = __webpack_public_path__ + "img/20201217_145445.fe7ed4ff.jpg";